import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { FunctionComponent, Suspense, lazy, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCheckPermissionQuery, useIsLoggedInQuery } from "../../graphql/generated/graphql";
import { ServiceWorkerState } from "../../shared/Hooks/useServiceWorker";
import Layout from "../../shared/LayoutWithTranslations";
import PermissionKeys from "../../shared/PermissionKeys";
import Home from "./index";

const HelpDialog = lazy(() => import(/* webpackChunkName: "partner-portal-module" */ "../PartnerPortal/Help"));

interface HomeWithLayoutProps
{
  appConfig: { env: string };
  serviceWorkerState: ServiceWorkerState;
}

const HomeWithLayout: FunctionComponent<HomeWithLayoutProps> = ({ appConfig, serviceWorkerState }) =>
{
  const { t } = useTranslation();
  const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);
  const { data: isLoggedInData } = useIsLoggedInQuery();

  const { data: checkWarehouseModulePermissionData, loading } = useCheckPermissionQuery({
    skip: !isLoggedInData?.isLoggedIn,
    variables: { PermissionKey: PermissionKeys.Warehouse.PWAModule }
  });

  const showPartnerPortalMenu = isLoggedInData?.isLoggedIn && !checkWarehouseModulePermissionData?.CheckPermission;

  const partnerPortalMenuItems = showPartnerPortalMenu ? (closeMenu: () => void) => (
    <MenuItem onClick={() => { closeMenu(); setIsHelpDialogOpen(true); }}>
      <ListItemIcon>
        <HelpOutlineIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={t('partnerPortal.help.menu')} />
    </MenuItem>
  ) : undefined;

  return (
    <>
      <Layout env={appConfig.env} serviceWorkerState={serviceWorkerState} menuItems={partnerPortalMenuItems}>
        <Home isLoggedIn={isLoggedInData?.isLoggedIn ?? false} hasWarehousePermission={checkWarehouseModulePermissionData?.CheckPermission ?? false} loading={loading} />
      </Layout>
      <Suspense fallback={null}>
        <HelpDialog open={isHelpDialogOpen} onClose={() => setIsHelpDialogOpen(false)} />
      </Suspense>
    </>
  );
};

export default HomeWithLayout;
